import * as React from 'react';
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { Grid, Typography, Button, Dialog } from "@mui/material";
import AdminInformation from "../components/admin-information-component";
import OrganisationInformation from "../components/organisation-information-component"
import ImageUploadCanvas from "../components/image-upload-component";
import SimpleBackdrop from "../components/backdrop-component";
import SetUpLink from "../components/setup-link-component";
import LoadingPage from "../components/loading-page-component";
import { useFormik } from "formik";
import * as yup from 'yup';
import { useTranslate } from "react-redux-multilingual";
import validator from "validator";
import md5 from "md5";
import { postcodeValidator } from 'postcode-validator';
import ReactGA from "react-ga4";

import {
    fetchLocationData,
    setOpenDialogBox,
    setcurrentScreen,
    createNewUser,
    setAdminLocationInfo,
    setCompanyLocationInfo,
    checkForDuplicateCompanyAlias,
    setopenEmailMessageBox,
    setcallCreateNewUserServlet,
    StripeSessionVerifyServlet,
    setcityError,
    setcompanyCityError,
    setthrowInvalidZipcodeError_Company,
    setthrowInvalidZipcodeError_Admin,
    setstripeVerifySessionServletCounter,
    setredirectToLoadingPage,
    returnKey,
    setHandleBackButtonConditionForScriptExecution,
    userApiTokenGenerate
} from '../reducers/global-reducer';
import { customLogs } from '../components/util/util';
import { useEffect } from 'react';

const SubscriptionPage = ({ route }) => {
    const [activeStep, setActiveStep] = React.useState(0);
    const [step, setStep] = React.useState('');
    const [load, setLoad] = useState(false)
    const [skipped, setSkipped] = React.useState(new Set());
    const [dataObj, setdataObj] = React.useState();
    const re = /^[A-Za-z\s]+$/;
    let { serviceID } = useParams();
    const [plan, setPlan] = useState(serviceID);
    const dispatch = useDispatch();
    const t = useTranslate();
    const store = useSelector(state => state);
    const {
        openDialogBox,
        adminLocationInfo,
        emailAddress,
        imageUrlAdmin,
        imageUrlCompany,
        companyLocationInfo,
        openEmailMessageBox,
        checkBoxChecked,
        callCreateNewUserServlet,
        externalAuthUserData,
        redirectToLoadingPage,
        createNewUserData,
        companyName,
        gstNumbr,
        useralias,
        countryDataArray,
        stripeVerifySessionServletCounter,
        openErrorPage,
        countryCode
    } = store.globalreducer;
    const { ssotype } = externalAuthUserData;
    const steps = [t('yourInformation'), t('billingDetails'), `${(serviceID.includes("WORDPRESS") || serviceID.includes("JODOMEETING")) ? t('setupDomainName') : t('setupJodoLink')}`];
    const MeetingSteps = [t('yourInformation'), t('billingDetails')];

    // Fetch the country list 
    React.useEffect(() => {
        dispatch(fetchLocationData(t))
    }, [])

    React.useEffect(() => {
        if (route === "existingUser") {
            setActiveStep(2);
            dispatch(setcurrentScreen(2))
        }
    }, [])
    // this use effect call StripeCreateServlet Api 
    React.useEffect(() => {
        if (callCreateNewUserServlet) {
            dispatch(createNewUser(dataObj))
            // dispatch(setTheWidgetSession(true))
        }

    }, [callCreateNewUserServlet])

    React.useEffect(() => {
        if (activeStep === 1 && serviceID.includes("JODOMEETING")) {
            setActiveStep(2)

        }
    },)

    React.useEffect(() => {
        if (Object.keys(createNewUserData).length !== 0) {
            dispatch(setstripeVerifySessionServletCounter(stripeVerifySessionServletCounter - 1))
            setTimeout(() => {
                dispatch(StripeSessionVerifyServlet({
                    "servicekey": createNewUserData.servicekey,
                    "apikey": createNewUserData.apikey
                }))
            }, 15000);
        }
    }, [createNewUserData])

    // utf ocde for the languages 
    const multiLangRegex = /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\u0600-\u06FF\u0900-\u097F.\s-]+(\s[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\u0600-\u06FF\u0900-\u097F.\s-]+)*$/;
    const addressRegex = /^[\u0020-\u007F\u00A0-\u024F\u0400-\u04FF\u0530-\u058F\u0600-\u06FF\u0750-\u077F\u0900-\u097F\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u1E00-\u1EFF0-9,\/\s-]+$/;
    const nameRegex = /^[\u0020-\u007F\u00A0-\u024F\u0400-\u04FF\u0530-\u058F\u0600-\u06FF\u0750-\u077F\u0900-\u097F\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u1E00-\u1EFF\d\s\-_]+$/u;
    const companyNameRegex1 = /^[\p{L}\p{N}\s\-@.#&!_,()[\u0020-\u007F\u00A0-\u024F\u0400-\u04FF\u0530-\u058F\u0600-\u06FF\u0750-\u077F\u0900-\u097F\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F]+$/u;
    const companyNameRegex2 = /^(?=.*[\p{L}\p{N}])/u;
    const aliasRegex = /^[\u0020-\u007F\u00A0-\u024F\u0400-\u04FF\u0530-\u058F\u0600-\u06FF\u0750-\u077F\u0900-\u097F\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u1E00-\u1EFF\d\-_]+$/u;

    // validation for all input field 
    let validationSchema = yup.object({
        firstName: yup
            .string()
            .required(t('firstNameRequired'))
            .max(25, t('twentyFiveCharValidation'))
            .matches(nameRegex, t('firstName_lastName_RegexValidation')),
        Password: yup
            .string()
            .required(t('passwordRequired'))
            .max(25, t('twentyFiveCharValidation'))
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, t('passwordRegexValidation')),

        confirmPassword: yup
            .string()
            .when("Password", {
                is: val => (val && val.length > 0 ? true : false),
                then: yup.string().oneOf(
                    [yup.ref("Password")],
                    t('confirmPasswordMatchValidation')
                )
            })
            .max(25, t('twentyFiveCharValidation'))
            .required(t('confirmPasswordRequired')),

        designation: yup
            .string()
            .matches(multiLangRegex, t('designationFieldValidation'))
            .max(25, t('designationLengthValidation')),

        country: yup
            .string()
            .matches(t('countryFieldValidation')),
        state: yup
            .string()
            .matches(t('stateFieldValidation')),


        ZipCode: yup.string()
            .matches(/^[0-9]+$/, t('zipNumberVAlidation'))
            .test('postcode', t('zipCodeValidation'), function (value) {
                if (value === undefined) {
                    return true
                } else {
                    try {
                        postcodeValidator(value, countryCode);
                        return postcodeValidator(value, countryCode)
                    } catch (error) {
                        customLogs(error)
                    }
                }
            }),

        address1: yup
            .string()
            .max(100, t('addressCharLengthValidation'))
            .matches(addressRegex, t('addressValidation')),

        address2: yup
            .string()
            .matches(addressRegex, t('addressValidation'))
            .max(100, t('addressCharLengthValidation')),
    });
    // if login type is not sso  then this validation are use  
    let validationSchemaPasswordAuth = yup.object({
        firstName: yup
            .string().trim()
            .required(t('firstNameRequired'))
            .max(255, t('twentyFiveCharValidation'))
            .matches(/^[a-zA-Z\s]*$/, t('firstName_lastName_RegexValidation')),

        designation: yup
            .string()
            .max(25, t('twentyFiveCharValidation')),
        country: yup
            .string()
            .matches(t('countryFieldValidation')),
        state: yup
            .string()
            .matches(t('stateFieldValidation')),


        ZipCode: yup
            .string()
            .matches(/^[0-9][0-9]{4,9}$/, t('zipcodeRegexValidation'))
            .max(10, t('zipcodeCharLengthValidation')),

        address1: yup
            .string()
            .matches(addressRegex, t('addressValidation'))
            .max(100, t('addressCharLengthValidation')),

        address2: yup
            .string()
            .matches(addressRegex, t('addressValidation'))
            .max(100, t('addressCharLengthValidation'))
    });

    const validationSchema_pageTwo = yup.object({
        companyNameRequired_: yup.boolean(),
        companyName: yup
            .string()
            .max(150, t('companyNameLengthValidation'))
            .matches(companyNameRegex1, t('companyName_RegexValidation'))
            .matches(companyNameRegex2, t("companyName_RegexValidation_2"))
            .when("companyNameRequired_", {
                is: true,
                then: yup.string().required(t('companyNameRequired'))
            }),

        gstNumber: yup
            .string()
            .max(25, t('twentyFiveCharValidation'))
            .matches(/^[a-zA-Z0-9 ]*$/, t('taxNo_RegexValidation')),

        ZipCode: yup
            .string()
            .matches(/^[0-9][0-9]{4,9}$/, t('zipcodeRegexValidation'))
            .max(10, t('zipcodeCharLengthValidation')),

        address1: yup
            .string()
            .matches(addressRegex, t('addressValidation'))
            .max(100, t('addressCharLengthValidation')),
        address2: yup
            .string()
            .matches(addressRegex, t('addressValidation'))
            .max(100, t('addressCharLengthValidation')),
        country: yup
            .string()
            .matches(t('countryFieldValidation')),
        state: yup
            .string()
            .matches(t('stateFieldValidation')),

    });

    const validationSchema_pageThree = yup.object({

        orgAlias: yup
            .string()
            .required(t('orgAliasRequired'))
            .max(25, t('twentyFiveCharValidation'))
            .matches(aliasRegex, t('aliasRegexValidation')),


        userAlias: yup
            .string()
            .required(t('userAliasRequired'))
            .max(25, t('twentyFiveCharValidation'))
            .matches(aliasRegex, t('aliasRegexValidation')),

    });


    const validationSchema_pageThree_JodoTeam = yup.object({

        orgAlias: yup
            .string()
            .required(t('orgAliasRequired'))
            .max(25, t('twentyFiveCharValidation'))
            .matches(aliasRegex, t('aliasRegexValidation')),
    });

    const validationSchema_pageThree_wordPress = yup.object({
        domainName: yup
            .string()
            .transform((value) => (value === undefined || value === null ? "" : value)) // Convert undefined/null to empty string
            .required(t('domainNameRequired'))
            .matches(/^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/, t('domainNameRegexValidation'))
            .matches(/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i, t('domainNameRegexValidation')),
    });

    const isStepSkipped = (step) => {
        return skipped.has(step);
    };

    //  this function will validate the zipcode 
    const validZipcodeChecker = (zipcodeValue, inputCountryValue) => {
        for (let { countrycode, countryname } of countryDataArray) {
            if (inputCountryValue === countryname) {
                if (validator.isPostalCodeLocales.includes(countrycode)) {
                    if (validator.isPostalCode(`${zipcodeValue}`, `${countrycode}`)) {
                        return "Zipcode is valid"
                    } else {
                        return "Invalid zipcode"
                    }
                } else {
                    return "Zipcode data not available"
                }
            }
        }
    }
    //initail value of textfield are defined 
    const formik = useFormik({
        initialValues: {
            firstName: (ssotype === "socialsso") ? (externalAuthUserData.firstname + " " + externalAuthUserData.lastname) : externalAuthUserData.firstname,
            Password: "",
            confirmPassword: "",
            designation: externalAuthUserData.designation ? externalAuthUserData.designation : "",
            ZipCode: adminLocationInfo.ZipCode,
            address1: adminLocationInfo.Address1,
            address2: adminLocationInfo.Address2,
            country: adminLocationInfo.CountryId,
            state: adminLocationInfo.StateId
        },
        validationSchema: (ssotype === "jodosso") ? validationSchema : validationSchemaPasswordAuth,
        onSubmit: (values) => {
            const moveToScreen2 = () => {
                dispatch(returnKey(md5(values.Password), t))
                dispatch(setAdminLocationInfo({ ...adminLocationInfo, ZipCode: values.ZipCode.trim(), Address1: values.address1.trim(), Address2: values.address2.trim() }))
                handleNext()
            }
            if (values.ZipCode.trim()) {
                dispatch(setopenEmailMessageBox(true))
                let isZipcodeValid = validZipcodeChecker(values.ZipCode, adminLocationInfo.CountryId);
                dispatch(setopenEmailMessageBox(false))
                if (isZipcodeValid === "Invalid zipcode") {
                    dispatch(setthrowInvalidZipcodeError_Admin(true))
                    return
                } else {
                    return moveToScreen2()
                }
            }
            moveToScreen2()
        },
    })
    // initial value of  second page of subscribtion  are define 
    const formik_pageTwo = useFormik({
        enableReinitialize: true,
        initialValues: {
            companyName: companyName,
            gstNumber: gstNumbr,
            ZipCode: companyLocationInfo.ZipCode,
            address1: companyLocationInfo.Address1,
            address2: companyLocationInfo.Address2,
            companyNameRequired_: !serviceID.includes("JODOLINKINDIVIDUAL")
        },
        validationSchema: validationSchema_pageTwo,
        onSubmit: (values) => {
            const movetoScreen3 = () => {
                dispatch(setCompanyLocationInfo({ ...companyLocationInfo, ZipCode: values.ZipCode, Address1: values.address1, Address2: values.address2 }))
                handleNext()
            }
            if (values.ZipCode.trim()) {
                dispatch(setopenEmailMessageBox(true))
                let isZipcodeValid = validZipcodeChecker(values.ZipCode, companyLocationInfo.CountryId);
                dispatch(setopenEmailMessageBox(false))
                if (isZipcodeValid === "Invalid zipcode") {
                    dispatch(setthrowInvalidZipcodeError_Company(true))
                    return
                } else {
                    return movetoScreen3()
                }
            }
            movetoScreen3()
        }
    })

    // inital values of last page of subscription 

    const formik_pageThree = useFormik({
        enableReinitialize: true,
        initialValues: {
            orgAlias: formik_pageTwo.values.companyName.replace(/[^a-zA-Z0-9]/g, ""),
            userAlias: route === "existingUser" ? useralias : (formik.values.firstName?.replace(/ /g, "") || ''),
        },
        validationSchema: serviceID.includes("JODOLINK") ? validationSchema_pageThree : serviceID.includes("JODOTEAM") ? validationSchema_pageThree_JodoTeam : (serviceID.includes("WORDPRESS")) && validationSchema_pageThree_wordPress,
        onSubmit: (values) => {
            let tempCompanyName = formik_pageTwo.values.companyName.trim() ? formik_pageTwo.values.companyName.trim() : formik.values.firstName.trim();
            // this payload pass to StripeCreateServlet api to create new user
            let DATA_OBJECT = {
                "userinfo": {
                    "username": formik.values.firstName.trim(),
                    "email": externalAuthUserData.ssotype === "jodosso" ? emailAddress : externalAuthUserData.email,
                    "ssomethod": externalAuthUserData.ssotype,
                    "password": md5(formik.values.Password).trim(),
                    "confirmpassword": md5(formik.values.confirmPassword).trim(),
                    "designation": formik.values.designation.trim(),
                    "country": String(adminLocationInfo.CountryId).trim(),
                    "state": String(adminLocationInfo.StateId).trim(),
                    "city": String(adminLocationInfo.CityId).trim(),
                    "pincode": String(adminLocationInfo.ZipCode).trim(),
                    "address1": formik.values.address1.trim(),
                    "address2": formik.values.address2.trim(),
                    "userimage": imageUrlAdmin,
                    "userbppalias": formik_pageThree.values.userAlias.trim(),
                    "language": store.globalreducer.language_email
                },
                "servicedetails": {
                    "servicename": `${serviceID.includes("JODOTEAM") ? "jodo_team" : serviceID.includes("JODOLINKINDIVIDUAL") ? "jodolink_individual" : serviceID.includes("JODOLINK") ? "jodo_bpp" : serviceID.includes("JODOMEETING") ? "jodomeeting" : "wordpress"}`,
                    // "domainname": `${formik_pageThree.values.domainName?.startsWith("https://") ? formik_pageThree.values.domainName?.substring(8) : formik_pageThree.values.domainName?.startsWith("http://") ? formik_pageThree.values.domainName?.substring(7) : formik_pageThree.values.domainName}`,
                    "domainname": formik_pageThree.values?.domainName
                        ? (formik_pageThree.values.domainName.startsWith("https://")
                            ? formik_pageThree.values.domainName.substring(8)
                            : formik_pageThree.values.domainName.startsWith("http://")
                                ? formik_pageThree.values.domainName.substring(7)
                                : formik_pageThree.values.domainName)
                        : "",  // Ensuring empty string if domainName is missing

                    "plan": (plan).includes("?") ? (plan).split('plan=')[1].split('?')[0] : (plan).split('plan=')[1]
                },
                "billingdetails": {
                    "companyname": tempCompanyName.charAt(0).toUpperCase() + tempCompanyName.slice(1),
                    "taxno": formik_pageTwo.values.gstNumber.trim(),
                    "country": checkBoxChecked ? String(adminLocationInfo.CountryId).trim() : String(companyLocationInfo.CountryId).trim(),
                    "state": checkBoxChecked ? String(adminLocationInfo.StateId).trim() : String(companyLocationInfo.StateId).trim(),
                    "city": checkBoxChecked ? String(adminLocationInfo.CityId).trim() : String(companyLocationInfo.CityId).trim(),
                    "pincode": checkBoxChecked ? String(adminLocationInfo.ZipCode) : String(companyLocationInfo.ZipCode),
                    "address1": checkBoxChecked ? adminLocationInfo.Address1.trim() : companyLocationInfo.Address1.trim(),
                    "address2": checkBoxChecked ? adminLocationInfo.Address2.trim() : companyLocationInfo.Address2.trim(),
                    "companylogo": imageUrlCompany,
                    "orgbppalias": formik_pageThree.values.orgAlias.trim()
                },
                "multilingual": t
            }
            setdataObj(DATA_OBJECT)
            handleNext()
        },
    })

    React.useEffect(() => {
        formik_pageThree.setValues({
            ...formik_pageThree.values,
            orgAlias: formik_pageTwo.values.companyName.replace(/[^a-zA-Z0-9]/g, ""),
            userAlias: route === "existingUser" ? useralias : (formik.values.firstName).replace(/[^a-zA-Z0-9]/g, ""),
        });
    }, [activeStep === 2])

    useEffect(() => {
        const isGoogle = localStorage.getItem("isGoogle")
        const isLinkedIn = localStorage.getItem("isLinkedin")
        console.log(isGoogle, "google")
        if (isGoogle || isLinkedIn) {
            const data = {
                "emailid": externalAuthUserData.email,
                "ssotype": isGoogle ? "google" : (isLinkedIn ? "linkedin" : ""),
                "sso_token": store.globalreducer.externalAuthUserData.random_token
            };
            // dispatch(userApiTokenGenerate(data));
        }
    }, [])


    //handle the next button 
    const handleNext = () => {

        let newSkipped = skipped;
        if (activeStep === 0) {
            if (adminLocationInfo.CountryId === "" || adminLocationInfo.StateId === "") return
            if (adminLocationInfo.CityId) {
                if (!re.test(adminLocationInfo.CityId)) {
                    return dispatch(setcityError(true))
                }
            }

            dispatch(setcurrentScreen(2))
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            setSkipped(newSkipped);
        }

        else if (activeStep === 1) {
            // Screen 2 Validation Part
            if (checkBoxChecked === false && (companyLocationInfo.CountryId === "" || companyLocationInfo.StateId === "")) return
            if (companyLocationInfo.CityId) {
                if (!re.test(companyLocationInfo.CityId)) {
                    return dispatch(setcompanyCityError(true))
                }
            }
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            dispatch(setcurrentScreen(3))
        }
        else {

            if (route === "existingUser") return
            if (serviceID.includes("WORDPRESS") || serviceID.includes("JODOMEETING")) {
                dispatch(setcallCreateNewUserServlet(true))

            } else {
                setLoad(true)
                dispatch(checkForDuplicateCompanyAlias({
                    "orgbppalias": formik_pageThree.values.orgAlias,
                    "emailid": externalAuthUserData.ssotype === "jodosso" ? emailAddress : externalAuthUserData.email,
                    "servicename": `${serviceID.includes("JODOTEAM") ? "jodo_team" : serviceID.includes("JODOLINK") ? "jodo_bpp" : "wordpress"}`
                }))
            }
            dispatch(setredirectToLoadingPage(true))
        }
        if (isStepSkipped(activeStep)) {
            newSkipped = new Set(newSkipped.values());
            newSkipped.delete(activeStep);
        }

        ReactGA.event({
            category: "User Interaction",
            action: "sub_handle_next_button",
            label: values.email
            // Name of the selected language
        });
    }

    // this function will handle the back button 
    const handleBack = () => {
        dispatch(setHandleBackButtonConditionForScriptExecution(2))
        if (activeStep === 1) {
            dispatch(setcurrentScreen(1))
        } else if (activeStep === 2) {
            dispatch(setcurrentScreen(2))
        }
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    // if service contains jodoMeet  the this function is use to handle back button 
    const handleBackMeet = () => {
        dispatch(setHandleBackButtonConditionForScriptExecution(2))

        if (activeStep === 2) {
            dispatch(setcurrentScreen(2))
        }
        setActiveStep((prevActiveStep) => prevActiveStep - 2);
    };


    const handleOpen = () => dispatch(setOpenDialogBox(true))
    const handleClose = () => dispatch(setOpenDialogBox(false))

    if (openErrorPage) {
        return
    } else {
        return (
            <>
                {
                    redirectToLoadingPage ?
                        <LoadingPage path="new_page" />
                        :
                        <>
                            <Grid container flexDirection={'column'} justifyContent={'center'} sx={{ marginTop: '-1rem' }}>
                                <div style={{ margin: '20px 0 0 0' }}>
                                    {
                                        serviceID.includes("JODOLINKINDIVIDUAL") ?
                                            <Typography textAlign={'center'} variant="heading">{t('jodoindi')}</Typography>
                                            :
                                            serviceID.includes("JODOLINK") ?
                                                <Typography textAlign={'center'} variant="heading">{t('jodolink')}</Typography>
                                                :
                                                serviceID.includes("WORDPRESS") ?
                                                    <Typography textAlign={'center'} variant="heading">{t('wordpress')}</Typography>
                                                    :
                                                    serviceID.includes("JODOMEETING") ?
                                                        <Typography textAlign={'center'} variant="heading">{t('jodomeeting')}</Typography>
                                                        :
                                                        <Typography textAlign={'center'} variant="heading">{t('jodoteam')}</Typography>
                                    }
                                </div>
                                {
                                    serviceID.includes("JODOMEETING") ?
                                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '20 0' }}>
                                            <Box sx={{ width: '82%' }}>
                                                <Stepper activeStep={activeStep}>
                                                    {MeetingSteps.map((label, index) => {
                                                        const stepProps = {};
                                                        const labelProps = {};
                                                        if (isStepSkipped(index)) {
                                                            stepProps.completed = false;
                                                        }
                                                        return (
                                                            <Step key={label} {...stepProps}>
                                                                <StepLabel sx={{ fontFamily: 'Josefin Sans SemiBold' }} {...labelProps}>{label}</StepLabel>
                                                            </Step>
                                                        );
                                                    })}
                                                </Stepper>
                                            </Box>
                                        </div>
                                        :
                                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: '20 0' }}>
                                            <Box sx={{ width: '82%' }}>
                                                <Stepper activeStep={activeStep}>
                                                    {steps.map((label, index) => {
                                                        const stepProps = {};
                                                        const labelProps = {};
                                                        if (isStepSkipped(index)) {
                                                            stepProps.completed = false;
                                                        }
                                                        return (
                                                            <Step key={label} {...stepProps}>
                                                                <StepLabel sx={{ fontFamily: 'Josefin Sans SemiBold' }} {...labelProps}>{label}</StepLabel>
                                                            </Step>
                                                        );
                                                    })}
                                                </Stepper>
                                            </Box>
                                        </div>
                                }

                                {serviceID.includes("JODOMEETING") ?
                                    <form autoComplete="off" onSubmit={activeStep === 0 ? formik.handleSubmit : activeStep === 1 ? formik_pageTwo.handleSubmit : activeStep === 1 ? formik_pageThree.handleSubmit : formik_pageThree.handleSubmit}>

                                        {
                                            activeStep === 0 ?
                                                // if active step is 0 then call AdminInformation component for filling user information
                                                <AdminInformation formik={formik} handleOpen={handleOpen} route={route} />
                                                :

                                                <div>
                                                    <OrganisationInformation serviceID={serviceID} formik={formik_pageTwo} userInfo={formik} route={route} />
                                                </div>
                                        }
                                        <Grid container justifyContent={'center'} sx={{ marginBottom: '30px' }}>

                                            {activeStep !== 0 && <Button variant="customPrimary"
                                                disabled={activeStep === 0 || callCreateNewUserServlet}
                                                onClick={handleBackMeet}
                                                sx={{ marginRight: "1rem" }}
                                            >
                                                {t('back')}
                                            </Button>}
                                            {

                                                <Button variant="customPrimary" type={"submit"} >
                                                    {activeStep === steps.length - 1 ? t('finish') : t('next')}
                                                </Button>

                                            }
                                        </Grid>
                                    </form>
                                    :
                                    <form autoComplete="off" onSubmit={activeStep === 0 ? formik.handleSubmit : activeStep === 1 ? formik_pageTwo.handleSubmit : formik_pageThree.handleSubmit}>

                                        {
                                            activeStep === 0 ?
                                                <AdminInformation formik={formik} handleOpen={handleOpen} route={route} />
                                                :
                                                activeStep === 1 ?
                                                    <OrganisationInformation serviceID={serviceID} formik={formik_pageTwo} userInfo={formik} route={route} />
                                                    :
                                                    <SetUpLink
                                                        formik={formik_pageThree}
                                                        service={serviceID}

                                                    />
                                        }
                                        <Grid container justifyContent={'center'} sx={{ marginBottom: '30px' }}>

                                            {activeStep !== 0 && <Button variant="customPrimary"
                                                disabled={activeStep === 0 || callCreateNewUserServlet}
                                                onClick={handleBack}
                                                sx={{ marginRight: "1rem" }}
                                            >
                                                {t('back')}
                                            </Button>}
                                            {

                                                <Button variant="customPrimary" type={"submit"} >
                                                    {activeStep === steps.length - 1 ? t('finish') : t('next')}
                                                </Button>


                                            }
                                        </Grid>
                                    </form>

                                }

                                {
                                    activeStep === steps.length - 1 &&
                                    <div style={{ marginTop: '-5rem' }}>
                                        {/* <LoadingPage path="setup_link_page" /> */}
                                    </div>
                                }

                            </Grid>
                            <Dialog
                                sx={{
                                    padding: '20px',
                                    '& .MuiPaper-root ': {
                                        padding: '15px 15px 0px 15px',
                                        width: '90%',
                                        height: '70%'
                                    },
                                }}
                                open={openDialogBox}
                                onClose={handleClose}
                            >
                                <Grid container justifyContent={"center"} alignItems={'center'} sx={{ height: '100%' }}>
                                    <ImageUploadCanvas />
                                </Grid>
                            </Dialog>
                            {openEmailMessageBox &&
                                <SimpleBackdrop open={openEmailMessageBox} childComponent={'loader'} />
                            }
                        </>
                }
            </>

        )
    }
}

export default SubscriptionPage;